import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { UsersManagement } from 'components/Settings/Components/UsersManagement/components/usersManagement';

export const UsersManagementPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userManagement.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader
                    title={settingsConfig.userManagement.title}
                    subTitle={'Add & edit user names and profiles'}
                />
            </HeaderWrapper>
            <MainContent>
                <UsersManagement />
            </MainContent>
        </PageContainer>
    );
};
